import { Injectable, signal } from "@angular/core";

/** Structured 403 payload from the entitlements engine. */
export interface LimitEvent {
  code: "limit_reached" | "upgrade_required";
  resource?: string;
  feature?: string;
  limit?: number | null;
  used?: number;
  message?: string;
}

/**
 * Global bridge between the HTTP interceptor and the in-context purchase
 * dialog: any request that fails with a structured limit_reached /
 * upgrade_required 403 opens the dialog right where the user is working.
 */
@Injectable({ providedIn: "root" })
export class LimitService {
  readonly event = signal<LimitEvent | null>(null);

  open(detail: LimitEvent) {
    this.event.set(detail);
  }

  close() {
    this.event.set(null);
  }
}
